import { render, staticRenderFns } from "./TiBI.vue?vue&type=template&id=6784610c"
import script from "./TiBI.vue?vue&type=script&lang=js"
export * from "./TiBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports